import { PrivacySettings } from "src/models/hierarchy";

/**
 * The most protective settings, the same as account-service's `DEFAULT_PRIVACY_SETTINGS`
 * (organization.entity.ts). The server returns effective values (FR-012); these fill any key an
 * older response leaves out, so the Overview and the Privacy tab never disagree.
 */
export const DEFAULT_PRIVACY_SETTINGS: PrivacySettings = {
  videoAllowed: false,
  videoRetentionDays: 7,
  resultsRetentionYears: 2,
  studentLoginEnabled: false,
  shareDob: false,
  letterDelivery: "print",
};

/** Stored settings with the defaults filled in for every missing key. */
export const effectivePrivacySettings = (
  stored: Partial<PrivacySettings> | null | undefined,
): PrivacySettings => {
  const effective = { ...DEFAULT_PRIVACY_SETTINGS };
  for (const key of Object.keys(DEFAULT_PRIVACY_SETTINGS) as Array<
    keyof PrivacySettings
  >) {
    const value = stored?.[key];
    if (value !== undefined && value !== null)
      (effective as Record<string, unknown>)[key] = value;
  }
  return effective;
};
